import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useLayoutEffect, useState } from 'react';
import { createUsers, fetchRoles, updateUser } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { Users } from './UsersColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import { Roles } from '../roles/RolesColumns';
import SpinnerForm from '../spinnner/SpinnerForm';
import axios from 'axios';
const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showUpdateUserDrawer: boolean;
    setShowUpdateUserDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    Users: Users
    getUsers: any
    setUserData: React.Dispatch<React.SetStateAction<Users | undefined>>;
}
const UpdateUserDrawer: React.FC<ProductsDrawerProps> = ({ showUpdateUserDrawer, setShowUpdateUserDrawer, Users, getUsers, setUserData }) => {
    const onCLose = () => {
        setUserData(undefined)
        setShowUpdateUserDrawer(false)
    }
    const [submitting, setSubmitting] = useState(false)
    const [rolesDisplay, setRolesDisplay] = useState<Roles[]>([])
    const [rolesOptions, setRolesOptions] = useState([])
    const [loadingForm, setLoadingForm] = useState(true)
        const [status, setStatus] = useState(Users?.status?.toString() || "0");
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate()

    useLayoutEffect(() => {
        const setFormValues = async () => {
            const role: any = rolesDisplay.find((c: any) => c.id === Users.role_id)

            form.setFieldsValue({
                role_id: role ? { value: role.id, label: role.name } : undefined,
                name: Users.user_name,
                email: Users.email,
                id: Users.id
            })
            setLoadingForm(false)
        };
        if (Users) {
            setFormValues()
        }
    }, [Users, rolesDisplay, form])

    const getRoles = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/roles', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: Roles[]) => {
                if (isMounted) {
                    setRolesDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        getRoles()
    }, [])


    useEffect(() => {
        const updatedRolesOptions: any = rolesDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }));
        setRolesOptions(updatedRolesOptions);
    }, [rolesDisplay])


    const filterRolesOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }



    const getClientIPAndURL = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const onFinish = (payload: any) => {
        setSubmitting(true)
        const extractedUser = {
            ...payload,
            role_id: payload.role_id?.value ? payload.role_id.value : payload.role_id
        }
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.put(`/api/v1/users/${extractedUser.id}`, extractedUser, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "User successfully updated",
                    `${extractedUser.email} was updated`,
                    'topRight'
                )
            }
            getUsers()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };


    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }
    
    return (
        <>
            <Drawer
                title="update  user"
                width={720}
                onClose={onCLose}
                open={showUpdateUserDrawer}
                bodyStyle={{ paddingBottom: 80 }}
                style={{
                    backgroundColor: 'white',
                    transition: 'transform 0.3s ease, opacity 0.3s ease'
                }}
                maskStyle={{
                    transition: 'opacity 0.3s ease'
                }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onCLose} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                    </div>
                }
            >

                {loadingForm ? (
                    <div>
                        <SpinnerForm />
                    </div>
                ) : (
                    <Form layout="vertical"
                        onFinishFailed={onFinishFailed}
                        onFinish={onFinish}
                        form={form}
                        initialValues={{
                            role_id: Users.role_id,
                            name: Users.user_name,
                            email: Users.email,
                            id: Users.id
                        }}
                        hideRequiredMark>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="name"
                                    label="name"
                                    rules={[{ required: true, message: 'Please enter name' }]}
                                >
                                    <Input
                                        placeholder="Please enter name"
                                        className='focus:border-green-500 hover:border-green-500'
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="email"
                                    label="email"
                                    rules={[{ required: true, message: 'Please enter email' }]}
                                >
                                    <Input
                                        placeholder="Please enter email"
                                        className='focus:border-green-500 hover:border-green-500'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="role_id"
                                    label="role name"
                                    rules={[{ required: true, message: 'Please slect product name' }]}
                                >
                                    <Select
                                        placeholder="Please select product name"
                                        showSearch
                                        style={{ borderColor: 'black' }}
                                        filterOption={filterRolesOptions}
                                    >
                                        {rolesOptions.map((option: any) => (
                                            <Option key={option.value} value={option.value}>{option.label}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                               <Col xs={24} sm={24} md={12} lg={12}>
                        <Form.Item
                            name="status"
                            label="Status"
                            rules={[{ required: true, message: "Please select a status" }]}
                        >
                            <Select
                                placeholder="Please select status"
                                value={form.getFieldValue('status')?.toString()} // Ensure correct format
                                onChange={(value) => form.setFieldsValue({ status: value })}
                            >
                                {status === "1" ? (
                                    <Option value="0">Deactivate</Option> // Show "Deactivate" when Active (1)
                                ) : (
                                    <Option value="1">Activate</Option> // Show "Activate" when Not Active (0)
                                )}
                            </Select>
                        </Form.Item>
                    </Col>
                         
                        </Row>
                           <Col span={12}>
                                <Form.Item
                                    name="id"
                                    label="id"
                                    hidden={true}
                                    rules={[{ required: true, message: 'Please enter password' }]}
                                >
                                    <Input
                                        placeholder="Please enter password"
                                        className='focus:border-green-500 hover:border-green-500'
                                    />
                                </Form.Item>
                            </Col>
                        <Row>
                            <Col span={12}>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>

                            {submitting && <Spin indicator={antIcon} />}
                        </Row>


                    </Form>
                )}

            </Drawer>
        </>
    )
}

export default UpdateUserDrawer;


